module.exports = __webpack_public_path__ + "static/img/plus-magenta.64be433f.svg";